// © Microsoft Corporation. All rights reserved.

import MediaInput from "../media-input/MediaInput";
import React from "react";
import { UGContentConnector } from "../../Social.props";
import { UGContent } from "@msnews/social-data-service";
import { SocialClassNameContract } from "../../Social.classnames";
import { SocialLocalizedStrings } from "../../Social.localizedStrings";

interface UGContentCreateView1Props {
    managedClasses?: SocialClassNameContract;
    ugContent?: UGContent;
    ugContentConnector: UGContentConnector;
    t: SocialLocalizedStrings;
}

interface UGContentCreateView1State extends UGContent { }

export default class UGContentCreateView1 extends React.Component<UGContentCreateView1Props, UGContentCreateView1State> {

    bodyContainerRef: React.RefObject<HTMLDivElement>;
    titleContainerRef: React.RefObject<HTMLDivElement>;

    constructor(props) {
        super(props);
        this.bodyContainerRef = React.createRef();
        this.titleContainerRef = React.createRef();
    }

    componentDidMount() {
        this.titleContainerRef.current.innerHTML = this.props.ugContent.title ? this.props.ugContent.title : "";
        this.bodyContainerRef.current.innerHTML = this.props.ugContent.body ? this.props.ugContent.body : "";
        const capture = {
            capture: true
        };

        window.addEventListener("keyup", this.handleKeypress, capture);
        window.addEventListener("keyupCapture", this.handleKeypress, capture);
        window.addEventListener("keypress", this.handleKeypress, capture);
        window.addEventListener("keypressCapture", this.handleKeypress, capture);
    }

    componentDidUpdate(prevProps) {
        if (this.props.ugContent.id != prevProps.ugContent.id) {
            this.titleContainerRef.current.innerHTML = this.props.ugContent.title ? this.props.ugContent.title : "";
            this.bodyContainerRef.current.innerHTML = this.props.ugContent.body ? this.props.ugContent.body : "";
        }
    }

    mediaInputChangeHandler(files) {
        Array.from(files).forEach(file => {
            this.props.ugContentConnector.saveUGContentResource(this.props.ugContent, file);
        });
    }

    changeHandler(e) {
        e.stopPropagation();
        if (e.currentTarget.dataset && e.currentTarget.dataset.textOnly && e.currentTarget.innerHTML != e.currentTarget.innerText) {
            e.currentTarget.innerHTML = e.currentTarget.innerText;
            this.placeCaretAtEnd(e.currentTarget);
        }
        this.props.ugContentConnector.saveUGContent({body: this.bodyContainerRef.current.innerText, title: this.titleContainerRef.current.innerText});
    }

    onRemoveResource (id) {
        const resources = this.props.ugContent.resources.filter(x => x.id != id);
        this.props.ugContentConnector.saveUGContent({resources});
    }

    onSetCoverResource (id) {
        const resources = this.props.ugContent.resources;
        resources.map(x => x.isCover = false);
        resources.find(x => x.id == id).isCover = true;
        this.props.ugContentConnector.saveUGContent({resources});
    }

    handleKeypress(e) {
        e.stopPropagation();
    }

    componentWillUnmount() {
        window.removeEventListener("keyup", this.handleKeypress);
        window.removeEventListener("keyupCapture", this.handleKeypress);
        window.removeEventListener("keypress", this.handleKeypress);
        window.removeEventListener("keypressCapture", this.handleKeypress);
    }

    render() {
        const { managedClasses, ugContent, t } = this.props;

        return (
            <div className={managedClasses.ugContentCreateView1Container}>
                <div className="cwt-content-generation-form">
                    <MediaInput
                        t= {t}
                        className="cwt-media-input"
                        managedClasses={managedClasses}
                        onChange={this.mediaInputChangeHandler.bind(this)}
                        onRemove={this.onRemoveResource.bind(this)}
                        onSetCover={this.onSetCoverResource.bind(this)}
                        resources={ugContent.resources}
                    />

                    <div className="cwt-text-input-group">
                        <div
                            data-textonly="true"
                            className="cwt-input cwt-rich-text-input cwt-title"
                            placeholder={t.UGCContentCreateV1ContentHeadlinePlaceHolder}
                            onBlur={this.changeHandler.bind(this)}
                            onPaste={this.changeHandler.bind(this)}
                            onKeyUp={this.changeHandler.bind(this)}
                            contentEditable={true}
                            suppressContentEditableWarning={true}
                            ref={this.titleContainerRef}
                        ></div>

                        <div
                            className="cwt-input cwt-rich-text-input cwt-body"
                            onBlur={this.changeHandler.bind(this)}
                            onKeyUp={this.changeHandler.bind(this)}
                            onPaste={this.changeHandler.bind(this)}
                            placeholder={t.UGCContentCreateV1ContentTextPlaceHolder}
                            contentEditable={true}
                            suppressContentEditableWarning={true}
                            ref={this.bodyContainerRef}
                        ></div>
                    </div>

                </div>
            </div>
        );
    }

    placeCaretAtEnd(el) {
        el.focus();
        if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
            const range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        }
    }
}
